import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AddPublicInformation from './components/AddPublicInformation';


const { Cell } = ResponsiveGrid;

const PublicInformationCreation = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="公設資料建立"
        // description="公設資料建立"
        breadcrumbs={[
          {
            name: '公設預約',
          },
          {
            name: '公設資料建立',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AddPublicInformation />
    </Cell>

    
  </ResponsiveGrid>
);

export default PublicInformationCreation;
